import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  Hidden,
  IconButton,
  Grid,
  createStyles,
  withStyles,
  WithStyles,
  useTheme,
  useMediaQuery,
} from "@material-ui/core";
import ProfileDrawer from "../StudentHeader/ProfileDrawer";
import hamburgerButton from "../../assets/icons/noun_List_3641712.png";
import profileButton from "../../assets/icons/noun_profile_339269.png";
import logo from "../../assets/ReadleeLogoRed.png";
import "./styles.scss";

const styles = () =>
  createStyles({
    customizeToolbar: {
      minHeight: 60,
      backgroundColor: "white",
    },
  });

interface AppHeaderProps extends WithStyles<typeof styles> {
  className: string;
  rightSide?: React.ReactNode;
  leftSide?: React.ReactNode;
  toggleSidebar?: () => void;
}
const AppHeader = withStyles(styles)(({ className, leftSide, rightSide, toggleSidebar, classes }: AppHeaderProps) => {
  const [profileOpen, setProfileOpen] = useState(false);
  const isSmall = useMediaQuery(useTheme().breakpoints.down("xs"));

  return (
    <AppBar elevation={0} position="static" className={`appHeader ${className}`}>
      <Toolbar className={classes.customizeToolbar} disableGutters={isSmall}>
        {toggleSidebar && (
          <Hidden mdUp>
            <IconButton onClick={toggleSidebar} size={isSmall ? "small" : "medium"}>
              <img className="IconImage>" src={hamburgerButton} alt="Menu" height={23} />
            </IconButton>
          </Hidden>
        )}
        <Link className="NavLink" to="/Home">
          <img src={logo} alt="Readlee" height={25} />
        </Link>
        {leftSide}
        <div style={{ flexGrow: 1 }}>
          <Hidden xsDown>
            <Grid container></Grid>
          </Hidden>
        </div>
        {rightSide}
        <IconButton onClick={() => setProfileOpen(!profileOpen)}>
          <img className="IconImage" src={profileButton} alt="Profile" height={23} />
        </IconButton>
      </Toolbar>
      <ProfileDrawer onClose={() => setProfileOpen(false)} onOpen={() => setProfileOpen(true)} open={profileOpen} />
    </AppBar>
  );
});

export default AppHeader;
